import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  autoCompleteInputRoot: {
    height: 46,
  },
}));
